import { withNamespaces } from "react-i18next";
import { Button } from "reactstrap";
import { isDsrFlagOn } from "../../hooks/useDsrDeadlineWorkflow";
import { formatDeadlineDate, getWaitingDurationLabel } from "../../utils";

const DeadlineManagementCard = ({ t, workflow, canEdit, onExtend, onResume }) => {
  const isAwaiting = isDsrFlagOn(workflow?.is_awaiting_requester);

  if (!isAwaiting) {
    return (
      <div className="dsr-deadline-extension">
        <div className="dsr-deadline-extension__title">{t("Deadline Extension")}</div>
        <p className="dsr-deadline-card__hint">
          {t(
            "Apply a formal extension under GDPR Article 12(3) (up to two additional months) when the request is complex or numerous."
          )}
        </p>
        {canEdit && (
          <Button
            color="primary"
            className="dsr-deadline-extension__button"
            type="button"
            onClick={onExtend}
          >
            <i aria-hidden="true" className="ri-calendar-line" />
            {t("Extend deadline")}
          </Button>
        )}
      </div>
    );
  }

  return (
    <div className="dsr-deadline-waiting">
      <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
        <div className="dsr-deadline-card__label mb-0">
          {t("Awaiting requester clarification")}
        </div>
        <span className="dsr-deadline-waiting__badge">{t("Waiting")}</span>
      </div>
      <p className="dsr-deadline-card__hint">
        {t("The workflow is waiting for additional information from the requester.")}
      </p>
      <div className="dsr-deadline-waiting__fields">
        <div>
          <div className="dsr-deadline-card__label">{t("Waiting since")}</div>
          <div className="dsr-deadline-card__value">
            {formatDeadlineDate(workflow?.awaiting_requester_started_at)}
          </div>
        </div>
        <div>
          <div className="dsr-deadline-card__label">{t("Elapsed waiting time")}</div>
          <div className="dsr-deadline-card__value">
            {getWaitingDurationLabel(workflow?.awaiting_requester_started_at, t)}
          </div>
        </div>
        <div>
          <div className="dsr-deadline-card__label">{t("Reason")}</div>
          <div className="dsr-deadline-card__value">
            {workflow?.awaiting_requester_reason || "—"}
          </div>
        </div>
      </div>
      {canEdit && (
        <Button color="primary" outline className="mt-3" onClick={onResume}>
          {t("Resume workflow")}
        </Button>
      )}
    </div>
  );
};

export default withNamespaces()(DeadlineManagementCard);
